import { useState, useRef, useEffect } from 'react';
import Navbar from '../Navigation/Navbar';
import UserBar from '../UserBar/UserBar';

/**
 * Header - Main application header with title, navbar, and user bar
 */
function Header() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const navRef = useRef(null);

  // Close the mobile nav on outside click, mirroring UserBar's dropdown pattern
  useEffect(() => {
    if (!isNavOpen) return;
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setIsNavOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isNavOpen]);

  // Close the mobile nav when a real nav link is clicked, but not for dropdown toggles
  // (profile avatar / alerts bell), which only open a submenu without navigating.
  const handleCollapseClick = (e) => {
    const link = e.target.closest('a');
    if (link && !link.classList.contains('dropdown-toggle')) {
      setIsNavOpen(false);
    }
  };

  return (
    <div className="header sub-container">
      <div id="header-text">
        <h1 id="title">SCRUMONLINE</h1>
        <p id="subtitle">Rapid planning and tracking tools for the next generation</p>
      </div>

      <div className="header-links">
        <nav className="navbar navbar-default" ref={navRef}>
          <div className="container-fluid">
            <div className="navbar-header">
              <button
                type="button"
                className={`navbar-toggle${isNavOpen ? '' : ' collapsed'}`}
                aria-expanded={isNavOpen}
                onClick={() => setIsNavOpen((open) => !open)}
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            </div>

            <div
              className={`collapse navbar-collapse${isNavOpen ? ' in' : ''}`}
              onClick={handleCollapseClick}
            >
              <Navbar />
              <div className="navbar-right user-bar">
                <UserBar />
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default Header;
